<template>
  <b-modal id="modal-editar" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title">Cancelar assinatura imediatamente</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-editar')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form>
      <h6>
        <p v-if="assinaturaEdicao"> Aluno: <strong>{{ assinaturaEdicao.user.email }}</strong></p>
        <br>
        <p v-if="assinaturaEdicao"> Plano: <strong>{{ assinaturaEdicao.plano.plano }}</strong></p>
      </h6>
      <div class="row mb-4">
        <div class="col-12 col-md-4">
            <label for="status">Status</label>
            <input v-if="assinaturaEdicao" readonly type="text" class="form-control" id="status" :value="assinaturaEdicao.status.descricao" />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6" >
            <label for="status">Data de Cancelamento</label>
            <template v-if="assinaturaEdicao">
              <input v-if="assinaturaEdicao.data_cancelamento" readonly type="datetime-local" class="form-control" id="data_cancelamento" v-model="assinaturaEdicao.data_cancelamento" />
              <input v-else readonly type="datetime" class="form-control" id="data_cancelamento" />
            </template>
        </div>
        <div class="form-group col-md-6">
            <label for="status">Data de Solicitação de Cancelamento</label>
            <template v-if="assinaturaEdicao">
              <input v-if="assinaturaEdicao.data_solicitacao_cancelamento" readonly type="datetime-local" class="form-control" id="data_solicitacao_cancelemento"
                  v-model="assinaturaEdicao.data_solicitacao_cancelamento" />
              <input v-else readonly type="datetime" class="form-control" id="data_solicitacao_cancelamento" />
            </template>
        </div>

        <div class="form-group col-md-12 mt-4">
            <label v-if="assinaturaMundipagg" for="assinaturaMundipagg">Status da assinatura na Mundipagg</label>
            <p id="assinaturaMundipagg" v-if="assinaturaMundipagg"><strong>{{ assinaturaMundipagg.status }}</strong></p>
            <!--<pre id="assinaturaMundipagg" v-if="assinaturaMundipagg">{{ JSON.stringify(assinaturaMundipagg, null, '\t') }}</pre>-->
        </div>
      </div>
      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <button class="btn btn-primary mr-3" type="button" @click="editarAssinatura">Cancelar assinatura</button>
          <button class="btn btn-primary mr-3" type="button" @click="buscaAssinaturaMundipagg">Consultar status na Mundipagg</button>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="fecharModal()">Sair</a>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import Swal from 'sweetalert2'
import AssinaturaAPI from '@/api/assinatura-api'
import ResponseUtils from '@/core/util/response-utils'
import DateUtils, { DateConstants } from '@/core/util/date-utils'

export default {
  name: 'ModalEditarAssinatura',
  components: {},
  props: {
    assinaturaEdicao: Object,
    tipos_status: Array,
    tipos_assinaturas: Array,
    assinaturaMundipagg: null
  },
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
    this.$root.$on('bv::modal::show', () => {
      if (this.assinaturaEdicao) {
        this.assinaturaEdicao.data_cancelamento = this.assinaturaEdicao.data_cancelamento ? DateUtils.formatDate(DateUtils.parse(this.assinaturaEdicao.data_cancelamento), DateConstants.DD_MM_YYYY_T) : null
        this.assinaturaEdicao.data_solicitacao_cancelamento = this.assinaturaEdicao.data_solicitacao_cancelamento ? DateUtils.formatDate(DateUtils.parse(this.assinaturaEdicao.data_solicitacao_cancelamento), DateConstants.DD_MM_YYYY_T) : null
      }
    })
  },
  methods: {
    show: function () {
      this.$bvModal.show('modal-editar')
    },
    buscaAssinaturaMundipagg: function () {
      const loader = this.$loading.show()
      AssinaturaAPI.buscaAssinaturaMundipagg(this.assinaturaEdicao.id, this.assinaturaEdicao.user.email).then(data => {
        if (data.length) {
          this.assinaturaMundipagg = data[0]
        } else {
          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Assinatura não localizada na Mundipagg'
          })
        }
        loader.hide()
      }).catch(error => ResponseUtils.handleError(error, loader))
    },
    editarAssinatura: function () {
      const loader = this.$loading.show()
      AssinaturaAPI.editaAssinatura(this.assinaturaEdicao).then(data => {
        loader.hide()
        Swal.fire({
          icon: 'success',
          showCloseButton: true,
          text: 'Assinatura cancelada com sucesso!'
        }).then(() => {
          this.$bvModal.hide('modal-editar')
          this.$emit('assinaturaAlterada', this.assinatura)
        })
      }).catch(error => ResponseUtils.handleError(error, loader))
    },
    fecharModal () {
      this.$bvModal.hide('modal-editar')
    }
  }
}
</script>
